export default "__VITE_ASSET__e32cf7ef__"